import { Injectable } from '@angular/core';

/**
 * Điều khiển trình xem ảnh dùng chung của cả app.
 *
 * Chỉ có MỘT thẻ <ms-image-viewer> duy nhất, đặt trong app.component.html —
 * ngay dưới <ion-router-outlet>, tức cùng cấp với nơi Ionic gắn modal. Nhờ vậy
 * nó nổi được lên trên mọi thứ mà không phải đụng tới DOM.
 *
 * Trang nào cần thì tiêm service này và gọi open(). Không cần đặt thẻ,
 * không cần khai báo biến trạng thái trong từng trang.
 */
@Injectable({ providedIn: 'root' })
export class MsImageViewerService {
  isOpen = false;
  images: string[] = [];
  index = 0;

  /** Tăng mỗi lần mở, để component biết mà đặt lại mức phóng to */
  version = 0;

  /**
   * @param images danh sách ảnh cùng một nhóm, để vuốt qua lại
   * @param current ảnh muốn mở trước, hoặc vị trí của nó
   */
  open(images: string[], current?: string | number) {
    const list = (images || []).filter(en => !!en);
    if (!list.length) {
      return;
    }
    let idx = 0;
    if (typeof current === 'number') {
      idx = current;
    } else if (typeof current === 'string') {
      idx = list.indexOf(current);
    }
    this.images = list;
    this.index = idx >= 0 && idx < list.length ? idx : 0;
    this.isOpen = true;
    this.version++;
  }

  close() {
    this.isOpen = false;
  }
}
